module.exports = __webpack_public_path__ + "static/media/tambola-arrow.3c4a3028.svg";